module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00591.9f3448cb.jpg";